// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';

// English components
import Navbar from './components/Navbar/Navbar';
import SocialIcons from './components/SocialIcons/SocialIcons';
import Home from './pages/Home';
import Work from './pages/Work';
import About from './pages/About';
import CV from './pages/CV';
import Email from './pages/Email';

// Polish components
import NavbarPL from './components/Navbar/NavbarPL';
import HomePL from './pages/HomePL';
import WorkPL from './pages/WorkPL';
import AboutPL from './pages/AboutPL';
import CVPL from './pages/CVPL';
import EmailPL from './pages/EmailPL';

import './App.css';

// Main app with language context
const AppContent = () => {
  const { language } = useLanguage();

  // Render components based on selected language
  return (
    <div className="app-container">
      {/* Select navbar based on language */}
      {language === 'en' ? <Navbar /> : <NavbarPL />}

      {/* Define your routes */}
      <Routes>
        {/* Default route -> Home page */}
        <Route path="/" element={language === 'en' ? <Home /> : <HomePL />} />
        {/* /work -> Work page */}
        <Route path="/work" element={language === 'en' ? <Work /> : <WorkPL />} />
        <Route path="/about" element={language === 'en' ? <About /> : <AboutPL />} />
        <Route path="/cv" element={language === 'en' ? <CV /> : <CVPL />} />
        <Route path="/email" element={language === 'en' ? <Email /> : <EmailPL />} />
      </Routes>

      <SocialIcons />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;